import { ReactNode } from "react";
import { MobileHeader } from "./mobileHeader";

export const PlainLayout = ({
  children,
  title,
  backTo,
}: {
  children: ReactNode;
  title?: string;
  backTo?: string;
}) => {
  return (
    <div className="w-screen h-screen max-h-[100dvh] flex flex-col bg-light-green-bg">
      <MobileHeader backTo={backTo} title={title} />

      <div className="overflow-y-scroll py-10 md:py-16 px-5 flex-1">
        {children}
      </div>
    </div>
  );
};
